import React from "react";
import {useSelector} from "react-redux";
import {selectStore} from "../../../../../../store/selector";
import {StyledStepFourExecutorAdmission} from "./index.styles";
import {EntrantAlertComponent} from "../../EntrantAlertComponent";
import {AdmissionUploadComponent} from "../../AdmissionUploadComponent";
import {Form} from "antd";
import {useTranslation} from "react-i18next";

export const FourthStep = ({formRef, onFinish, onFinishFailed, isExecutor, educationOrder}: any) => {
  const {t} = useTranslation('executorAdmissionSteps')

  const {admission: {stepsData: data, getMarks: markTable}} = useSelector(selectStore)

  // Преобразование массива документов в структуру fileList для Upload компонента
  const docsToFileList = (docs:any) => {
    return docs.map((doc:any) => ({
      uid: doc.id,
      name: doc.name,
      status: 'done',
      url: doc.url
    }));
  };

// Инициализация начальных значений для формы
  const initValue = {
    photo3_4: [],
    doc_education: [],
    executor_doc: [],
    doc_health: [],
    doc_entrant_foreign: [],
    doc_entrant_without_citizenship: [],
    doc_entrant_search_shelter: [],
    doc_entrant_candas: [],
    doc_entrant_refugee: [],
    doc_entrant_id: [],
    doc_ud_parent: [],
    doc_ud_parent_foreigner: [],
    doc_ud_parent_without_citizenship: [],
    doc_ud_parent_search_shelter: [],
    doc_ud_parent_candas: [],
    doc_ud_parent_refugee: [],
    op: [],
    doc_op_parent_foreigner: [],
    doc_op_parent_without_citizenship: [],
    doc_op_parent_search_shelter: [],
    doc_op_parent_candas: [],
    doc_op_parent_refugee: [],
    doc_op_parent_id: [],
    doc_invalid1and2: [],
    doc_vov: [],
    doc_village_soc_ek: [],
    doc_faces_kaz_nac_without_rk: [],
    doc_children_without_parent: [],
    doc_village_rk: [],
    doc_children_many: [],
    doc_family_half: [],
    doc_family_with_invalid: [],
    doc_formaMedic: [],
    doc_conscript: [],
  };

// Преобразование массива документов в объект, где ключами будут типы документов, а значениями - fileList
  const docsToInitialValues = (docs:any) => {
    return docs.reduce((acc:any, doc:any) => {
      if (!acc[doc.type]) {
        acc[doc.type] = [];
      }
      acc[doc.type].push({
        uid: doc.id,
        name: doc.name,
        status: 'done',
        url: doc.url
      });
      return acc;
    }, {});
  };

  const mergedInitialValues = {
    ...initValue,
    ...docsToInitialValues(educationOrder?.data?.docs)
  };


  // @ts-ignore
  return (
    <StyledStepFourExecutorAdmission>
      <div className="header">
        <h2>
          {t("documentsTitle")}
        </h2>
      </div>

      <div className="body">

        <EntrantAlertComponent/>

        <h2 style={{marginBottom: '32px'}}>{t('stepFour.label')}</h2>

        <Form
          form={formRef}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          onFinish={onFinish}
          initialValues={mergedInitialValues}
        >

          {/* стандарт */}

          <AdmissionUploadComponent
            title={'stepFour.photo3_4'}
            name="photo3_4"
            required={!isExecutor}
          />
          <AdmissionUploadComponent
            title={'stepFour.attestat'}
            name="doc_education"
            required={true}
          />
          <AdmissionUploadComponent
            title={'stepFour.applicationForTraining'}
            name="executor_doc"
            required={false}
          />
          <AdmissionUploadComponent
            title={'stepFour.spravka'}
            name="doc_health"
            required={!isExecutor}
          />

          {/*Абитуриент Иностранец*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "1" && data?.declarant_status === "3" &&
            <AdmissionUploadComponent
              title={'stepFour.inocstranec'}
              name="doc_entrant_foreign"
              required={!isExecutor}
            />
          }

          {/*Абитуриент Лицо, без гражданства*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "1" && data?.declarant_status === "6" &&
            <AdmissionUploadComponent
              title={'stepFour.bezGrajdanstva'}
              name="doc_entrant_without_citizenship"
              required={!isExecutor}
            />
          }

          {/*Абитуриент Лицо, ищущее убежище*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "1" && data?.declarant_status === "5" &&
            <AdmissionUploadComponent
              title={'stepFour.iwuwiUbejiwe'}
              name="doc_entrant_search_shelter"
              required={!isExecutor}
            />
          }

          {/*Абитуриент Кандас*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "1" && data?.declarant_status === "2" &&
            <AdmissionUploadComponent
              title={'stepFour.udKandasa'}
              name="doc_entrant_candas"
              required={!isExecutor}
            />
          }

          {/*Абитуриент Беженец*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "1" && data?.declarant_status === "4" &&
            <AdmissionUploadComponent
              title={'stepFour.udBejenca'}
              name="doc_entrant_refugee"
              required={!isExecutor}
            />
          }

          {/*Абитуриент Гражданин РК*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "1" && data?.declarant_status === "1" &&
            <AdmissionUploadComponent
              title={'stepFour.udEntrant'}
              name="doc_entrant_id"
              required={!isExecutor}
            />
          }


          {/*Родитель*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "2" &&
            <>
              <AdmissionUploadComponent
                title={'stepFour.udRoditelya'}
                name="doc_ud_parent"
                required={!isExecutor}
              />

              {/* удостоверение ребенка (написано поступающего студента)*/}
              {/*<AdmissionUploadComponent*/}
              {/*  title={'stepFour.udStudent'}*/}
              {/*  name="doc_ud"*/}
              {/*  required={!isExecutor}*/}
              {/*/>*/}
            </>
          }

          {/*Родитель Иностранец*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "2" && data?.declarant_status === "3" &&
            <AdmissionUploadComponent
              title={'stepFour.inocstranec'}
              name="doc_ud_parent_foreigner"
              required={!isExecutor}
            />
          }

          {/*Родитель Лицо, без гражданства*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "2" && data?.declarant_status === "6" &&
            <AdmissionUploadComponent
              title={'stepFour.bezGrajdanstva'}
              name="doc_ud_parent_without_citizenship"
              required={!isExecutor}
            />
          }

          {/*Родитель Лицо, ищущее убежище*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "2" && data?.declarant_status === "5" &&
            <AdmissionUploadComponent
              title={'stepFour.iwuwiUbejiwe'}
              name="doc_ud_parent_search_shelter"
              required={!isExecutor}
            />
          }

          {/*Родитель Кандас*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "2" && data?.declarant_status === "2" &&
            <AdmissionUploadComponent
              title={"stepFour.udKandasa"}
              name="doc_ud_parent_candas"
              required={!isExecutor}
            />
          }

          {/*Родитель Беженец*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "2" && data?.declarant_status === "4" &&
            <AdmissionUploadComponent
              title={"stepFour.udBejenca"}
              name="doc_ud_parent_refugee"
              required={!isExecutor}
            />
          }

          {/*/!*Родитель Гражданин РК*!/*/}
          {/*/!*@ts-ignore*!/*/}
          {/*{data?.declarant_type === "2" && data?.declarant_status === "1" &&*/}
          {/*  <AdmissionUploadComponent*/}
          {/*    title={"stepFour.udEntrant"}*/}
          {/*    name="doc_ud_parent"*/}
          {/*    required={!isExecutor}*/}
          {/*  />*/}
          {/*}*/}

          {/*Опекун*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "3" &&
            <AdmissionUploadComponent
              title={"stepFour.docOpecun"}
              name="op"
              required={!isExecutor}
            />
          }

          {/*Опекун Иностранец*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "3" && data?.declarant_status === "3" &&
            <AdmissionUploadComponent
              title={"stepFour.inocstranec"}
              name="doc_op_parent_foreigner"
              required={!isExecutor}
            />
          }

          {/*Опекун Лицо, без гражданства*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "3" && data?.declarant_status === "6" &&
            <AdmissionUploadComponent
              title={"stepFour.bezGrajdanstva"}
              name="doc_op_parent_without_citizenship"
              required={!isExecutor}
            />
          }

          {/*Опекун Лицо, ищущее убежище*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "3" && data?.declarant_status === "5" &&
            <AdmissionUploadComponent
              title={"stepFour.iwuwiUbejiwe"}
              name="doc_op_parent_search_shelter"
              required={!isExecutor}
            />
          }

          {/*Опекун Кандас*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "3" && data?.declarant_status === "2" &&
            <AdmissionUploadComponent
              title={"stepFour.udKandasa"}
              name="doc_op_parent_candas"
              required={!isExecutor}
            />
          }

          {/*Опекун Беженец*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "3" && data?.declarant_status === "4" &&
            <AdmissionUploadComponent
              title={"stepFour.udBejenca"}
              name="doc_op_parent_refugee"
              required={!isExecutor}
            />
          }

          {/*Опекун Гражданин РК*/}
          {/*@ts-ignore*/}
          {data?.declarant_type === "3" && data?.declarant_status === "1" &&
            <AdmissionUploadComponent
              title={"stepFour.udEntrant"}
              name="doc_op_parent_id"
              required={!isExecutor}
            />
          }

          {/*Квота*/}
          {/*@ts-ignore*/}
          {data?.quota === "1" && data?.invalid1and2 === "1" &&
            <AdmissionUploadComponent
              title={"stepTwo.quota.listOfQuotes.invalid1and2"}
              name="doc_invalid1and2"
              required={!isExecutor}
            />
          }
          {/*@ts-ignore*/}
          {data?.quota === "1" && data?.vov === "1" &&
            <AdmissionUploadComponent
              title={"stepTwo.quota.listOfQuotes.vov"}
              name="doc_vov"
              required={!isExecutor}
            />
          }
          {/*@ts-ignore*/}
          {data?.quota === "1" && data?.village_soc_ek === "1" &&
            <AdmissionUploadComponent
              title={"stepTwo.quota.listOfQuotes.village_soc_ek"}
              name="doc_village_soc_ek"
              required={!isExecutor}
            />
          }
          {/*@ts-ignore*/}
          {data?.quota === "1" && data?.faces_kaz_nac_without_rk === "1" &&
            <AdmissionUploadComponent
              title={"stepTwo.quota.listOfQuotes.faces_kaz_nac_without_rk"}
              name="doc_faces_kaz_nac_without_rk"
              required={!isExecutor}
            />
          }
          {/*@ts-ignore*/}
          {data?.quota === "1" && data?.children_without_parent === "1" &&
            <AdmissionUploadComponent
              title={"stepTwo.quota.listOfQuotes.children_without_parent"}
              name="doc_children_without_parent"
              required={!isExecutor}
            />
          }
          {/*@ts-ignore*/}
          {data?.quota === "1" && data?.village_rk === "1" &&
            <AdmissionUploadComponent
              title={"stepTwo.quota.listOfQuotes.village_rk"}
              name="doc_village_rk"
              required={!isExecutor}
            />
          }
          {/*@ts-ignore*/}
          {data?.quota === "1" && data?.children_many === "1" &&
            <AdmissionUploadComponent
              title={"stepTwo.quota.listOfQuotes.children_many"}
              name="doc_children_many"
              required={!isExecutor}
            />
          }
          {/*@ts-ignore*/}
          {data?.quota === "1" && data?.family_half === "1" &&
            <AdmissionUploadComponent
              title={"stepTwo.quota.listOfQuotes.family_half"}
              name="doc_family_half"
              required={!isExecutor}
            />
          }
          {/*@ts-ignore*/}
          {data?.quota === "1" && data?.family_with_invalid === "1" &&
            <AdmissionUploadComponent
              title={"stepTwo.quota.listOfQuotes.family_with_invalid"}
              name="doc_family_with_invalid"
              required={!isExecutor}
            />
          }

          {/*Дети с ограниченными возможностями в развитии*/}
          {/*@ts-ignore*/}
          {data?.invalid_child === "1" &&
            <AdmissionUploadComponent
              title={"stepFour.formaMedic"}
              name="doc_formaMedic"
              required={!isExecutor}
            />
          }

          {/*Граждане Республики Казахстан, выслужившие установленный срок срочной воинской службы по призыву*/}
          {/*@ts-ignore*/}
          {data?.conscript === "1" &&
            <AdmissionUploadComponent
              title={"stepFour.conscript"}
              name="doc_conscript"
              required={!isExecutor}
            />
          }



        </Form>
      </div>
    </StyledStepFourExecutorAdmission>
  )
}